import { useMemo } from 'react'
import { useWindowSize } from './useWindowSize'

export interface Resolution {
  width: number;
  height: number;
}

export const useOrientation = (res: Resolution) => {
  const windowSize = useWindowSize()

  const resolution = useMemo(() => {
    return windowSize.width > windowSize.height
      ? { width: res.width, height: res.height } // Landscape
      : { width: res.height, height: res.width } // Portrait
  }, [res, windowSize])

  return resolution
}
